var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_573_68182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7278 15.941C31.7278 24.7449 24.6262 31.8819 15.8659 31.8819C7.10555 31.8819 0.00390625 24.7449 0.00390625 15.941C0.00390625 7.13701 7.10555 0 15.8659 0C24.6262 0 31.7278 7.13701 31.7278 15.941Z",
    fill: "black",
    fillOpacity: 0.52
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.00391,
    y: 12.021,
    width: 1.30068,
    height: 7.5873,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.30469,
    y: 12.021,
    width: 1.30068,
    height: 7.5873,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.60547,
    y: 7.90234,
    width: 1.30068,
    height: 15.8249,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.90625,
    y: 4,
    width: 1.30068,
    height: 23.629,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.207,
    y: 6.38477,
    width: 1.30068,
    height: 18.8599,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5078,
    y: 9.85303,
    width: 1.30068,
    height: 11.9229,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8086,
    y: 7.90234,
    width: 1.30068,
    height: 15.8249,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1094,
    y: 12.021,
    width: 1.30068,
    height: 7.5873,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4102,
    y: 7.90234,
    width: 1.30068,
    height: 15.8249,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7109,
    y: 13.3218,
    width: 1.30068,
    height: 4.98594,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0117,
    y: 9.85303,
    width: 1.30068,
    height: 11.9229,
    rx: 0.65034,
    fill: "#1CE730"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3125,
    y: 12.021,
    width: 1.30068,
    height: 7.5873,
    rx: 0.65034,
    fill: "#1CE730"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_573_68182",
    x: -29.9933,
    y: -29.9972,
    width: 91.7171,
    height: 91.8763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.9986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_573_68182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_573_68182",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIndicator);
export default __webpack_public_path__ + "static/media/voice-indicator.8e670697343bd0e05f9c522e2e510919.svg";
export { ForwardRef as ReactComponent };